import { render, staticRenderFns } from "./PresentationDetails.vue?vue&type=template&id=74b07790&"
import script from "./PresentationDetails.vue?vue&type=script&lang=js&"
export * from "./PresentationDetails.vue?vue&type=script&lang=js&"
import style0 from "./PresentationDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports